import Reflux from 'reflux-react-16'
import socket from '../socketio/socketio.js'

import LoginActions from '../actions/LoginActions.js'
import moment from 'moment'

export default class LoginStore extends Reflux.Store {
    constructor() {
        super()

        this.listenables = LoginActions

        this.state = {
            reseller: {settings: {shifts: {}, orders: {}}},
            user: {settings: {}, accounts: []},
            branding: undefined,
            brandingLoading: true
        }

        localStorage.mLastActiveTime = localStorage.mLastActiveTime || moment().toISOString(true)

        if (moment().diff(moment(localStorage.mLastActiveTime), 'hours') > 8) {
            LoginActions.logout()
        }

        this.interval = setInterval(() => {
            if (moment().diff(moment(localStorage.mLastActiveTime), 'hours') > 8) {
                LoginActions.logout()
            }
        }, 60000)

        window.document.addEventListener('click', () => {
            localStorage.mLastActiveTime = moment().toISOString(true)
        }, {passive: false})

        const domain = window?.location.hostname

        if (!['localhost', 'dev.veloyd.nl', 'test.veloyd.nl', 'app.veloyd.nl'].includes(domain)) {
            LoginActions.getBranding(domain, (error, branding) => {
                if (!error && branding) {
                    this.setState({branding, brandingLoading: false})
                } else {
                    this.setState({brandingLoading: false})
                }
            })
        } else {
            this.state.branding = {}
            this.state.brandingLoading = false
        }

        if (localStorage.mtoken) {
            LoginActions.getAccount()
            LoginActions.getReseller()
        }

        socket.on('updateUser', () => {
            LoginActions.getAccount()
        })

        socket.on('updateReseller', () => {
            LoginActions.getReseller()
        })
    }

    onGetAccounts(email, password, callback) {
        socket.emit('login.getAccountsMessenger', email, password, callback)
    }

    onLogin(token, index, code, callback) {
        socket.emit('login.login', token, index, code, (err, token, user, reseller) => {
            if (err) {
                callback(err)
                return
            }

            if (checkRedirectToNewDomain(reseller?.domain, true, reseller?.settings?.brandingEnabled)) return

            localStorage.mtoken = token

            this.setState({reseller, user})
            // TODO: this is a hack, should be done in a better way, user returned from login.login is not complete
            LoginActions.getAccount()

            callback()
        })
    }

    onSwitchAccount(index, code, callback) {
        socket.emit('login.login', localStorage.mtoken, index, code, (err, token, user, reseller) => {
            if (err) {
                callback(err)
                return
            }

            if (checkRedirectToNewDomain(reseller?.domain, true, reseller?.settings?.brandingEnabled)) return

            localStorage.mtoken = token
            window.location = '/koerier'
        })
    }

    onLogout() {
        localStorage.removeItem('mtoken')
        localStorage.removeItem('mLastActiveTime')
        window.location = '/koerier/login'
    }

    onLoggedIn(callback) {
        if (!localStorage.mtoken) {
            callback(false)
            return
        }

        this.onCheck2FARequiredAndSetup((err) => {
            callback(!err)
        })
    }

    onGetAccount() {
        socket.emit('login.getAccount', localStorage.mtoken, (err, user) => {
            if (!err) {
                this.setState({user: {...this.state.user, ...user}})
            }
        })
    }

    onUpdateUserSettings(user, callback) {
        socket.emit('users.updateSettings', localStorage.mtoken, user.settings, callback)
    }

    onGetReseller() {
        socket.emit('login.getReseller', localStorage.mtoken, (err, reseller, domain) => {
            if (!err) {
                if (checkRedirectToNewDomain(domain, true, reseller?.settings?.brandingEnabled)) return
                this.setState({reseller})
            }
        })
    }

    onGenerateMFAKey(token, accountIndex, callback) {
        socket.emit('login.generateMFAKey', localStorage.mtoken || token, accountIndex, callback)
    }

    onMailMFACode(token, ...args) {
        socket.emit('login.mailMFACode', localStorage.mtoken || token, ...args)
    }

    onReset2FA(token, ...args) {
        socket.emit('login.reset2FA', localStorage.mtoken || token, ...args)
    }

    onCheck2FARequiredAndSetup(...args) {
        socket.emit('login.check2FARequiredAndSetup', localStorage.mtoken, ...args)
    }

    onCheckNotifications(callback) {
        socket.emit('login.checkNotifications', localStorage.mtoken, (err, notifications) => {
            if (!err && notifications) {
                this.setState({notifications})
                typeof callback === 'function' && callback()
            }
        })
    }

    onUpdateReadNotifications(...args) {
        socket.emit('login.updateReadNotifications', localStorage.mtoken, ...args)
    }

    onGetBranding(domain, callback) {
        socket.emit('login.getBranding', domain, (err, branding) => {
            this.setState({branding})
            typeof callback === 'function' && callback(err, branding)
        })
    }
}

function checkRedirectToNewDomain(brandingDomain, keepPath, brandingEnabled) {
    let newDomain
    const currentDomain = `${location.protocol}//${location.host}`
    const currentHostname = location.hostname

    if (!brandingDomain || (!brandingEnabled && ![brandingDomain, 'localhost', 'dev.veloyd.nl', 'test.veloyd.nl', 'app.veloyd.nl'].includes(currentHostname))) {
        if (currentHostname.includes('localhost')) {
            newDomain = `${location.protocol}//localhost${location.port ? `:${location.port}` : ''}`
        }

        if (currentHostname.includes('veloyd.nl')) {
            newDomain = `${location.protocol}//app.veloyd.nl`
        }

        if (currentHostname.includes('test.veloyd.nl')) {
            newDomain = `${location.protocol}//test.veloyd.nl`
        }

        if (currentHostname.includes('dev.veloyd.nl')) {
            newDomain = `${location.protocol}//dev.veloyd.nl`
        }
    } else if (brandingEnabled) {
        newDomain = `${location.protocol}//${brandingDomain}${process.env.NODE_ENV === 'local' && location.port ? `:${location.port}` : ''}`

        if (currentHostname === 'localhost') {
            newDomain = `${location.protocol}//${brandingDomain}${process.env.NODE_ENV === 'local' && location.port ? `:${location.port}` : ''}`
        }
    } else {
        newDomain = currentDomain
    }

    if (newDomain && newDomain !== currentDomain) {
        if (keepPath) {
            newDomain = `${newDomain}${location.pathname}${location.search}`
        } else {
            newDomain = `${newDomain}/koerier`
        }

        // Logout current user
        localStorage.removeItem('mtoken')
        localStorage.removeItem('mLastActiveTime')

        window.location.href = newDomain
        return true
    }
}
